const variables = {
  state: {
    mapbox: {
      accessToken: '',
      defaultOptions: {
        style: 'https://api.maptiler.com/maps/07b5cdb5-4155-4d87-91b0-165d53384fec/style.json?key=EiCgsIZ0YBbXRdNSx4X8',
      },
    },
    environment: {
      production: 'https://element-iot.com',
      stage: 'https://stage.element-iot.com',
    },
  },
};

export default variables;
